import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-error-animation',
  templateUrl: './error.animation.html',
  styleUrls: ['./error.animation.scss']
})
export class ErrorAnimation implements OnInit {

  @Input() message = '';

  constructor() { }

  ngOnInit() {
  }
}